//* adavis/whitelabel_api_requests
//* "version": "1.0.38"

import getApiClient from './Api/api_client';
import config from '../promotion_config';

export default () => {
    return getApiClient(config);
};

/*
    the config object here is any json object that we wish to be used in our APIs.
    In this case, it is appUrl being passed in to call FauxAPI endpoints.
    For james bond, it looks like:
    {
        appUrl: "/jamesbondlotterychallenge",
        routes: {
            login: "scbzApi.login",
            logout: "scbzApi.logout",
            enterDrawTicket: "scbzApi.enterDrawTicket",
            getEntries: "scbzApi.getEntries",
            getPlayerData: "scbzApi.getPlayerData",
            setEntryFlashGameFlag: "scbzApi.setEntryFlashGameFlag",
            update: "fauxScbzApi.update",
            register: "fauxScbzApi.register",
            winners: "fauxScbzApi.winners",
            postFeedback: "fauxScbzApi.postFeedback",
            forgotPassword: "fauxScbzApi.forgotPassword",
            getGame: "fauxScbzApi.getGame",
            getGameOver: "fauxScbzApi.getGameOver",
        }
    }
*/
